import Axios, { AxiosRequestConfig } from 'axios';
import {
  URL_BACKEND_ROOT
} from "../app/AppConst";
import { AttributeChoiceEntity } from '../dto/attribute/AttributeChoiceEntity';
import { ApiClient } from '../util/ApiUtility';

export const onAttributeChoiceUpdate = async (AttributeChoice: AttributeChoiceEntity) => { // create & update same api
  const requestConfig: AxiosRequestConfig = {
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
    url: `${URL_BACKEND_ROOT}` + '/v1/cms/attribute/choice/update',
    data: AttributeChoice
  }
  const response = await ApiClient().request(requestConfig);

  if (response.status >= 200 && response.status < 300) {
    return response.data;
  } else {
    throw new Error("Амжилтгүй");
  }
}